export const INCORRECT_ITERABLE_INPUT = 'Incorrect iterable input'
